import { Table } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { amountFormat } from "../../../../utils";
import AxiosInstance from "../../../../AxiosInstance";
import { PartnerContext } from "../PartnerOutlet";

import styles from "../partnerDashboard.module.css";
export default function PartnerPHTableView() {
  const partnerContext = useContext(PartnerContext);
  const [loading, setLoading] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [status, setStatus] = useState("ACTIVE");
  var [dataSource, setDataSource] = useState([]);
  const [summaryData, setSummaryData] = useState({});

  useEffect(() => {
    let ignore = false;

    if (!ignore) {
      getTableData(0);
      // getSummaryData();
    }
    return () => {
      ignore = true;
    };
  }, []);
  const getTableData = async (skip) => {
    const url = `/partner/referral/${partnerContext.viewMode}/list?take=10&skip=${skip}`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setPolicies(data.data);
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      })
      .catch((err) => {});
  };

  const columns = [
    // {
    //   title: "Refer Date",
    //   dataIndex: "createdAt",
    //   key: "createdAt",
    //   render: (text, policy) => moment(policy.createdAt).format("DD/MM/YYYY"),
    // },
    {
      title: "PH Name",
      dataIndex: "role",
      key: "role",
      align: "center",
      render: (text, policy) => policy["firstName"] + " " + policy["lastName"],
    },
    {
      title: "No. of Policies",
      dataIndex: "totalPolicyCount",
      key: "totalPolicyCount",
      align: "center",
    },
    {
      title: "Assignment Offer Amount",
      dataIndex: "totalInvestmentAmount",
      key: "totalInvestmentAmount",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
    {
      title: "Growth",
      dataIndex: "growthRatio",
      key: "growthRatio",
      align: "center",
      render: (text, policy) =>
        text ? parseFloat(text).toFixed(1) + " %" : "N/A",
    },
    {
      title: "Current Value",
      dataIndex: "totalCurrentSurrenderValue",
      key: "totalCurrentSurrenderValue",
      align: "right",
      render: (text, policy) => <>{text ? amountFormat(text) : "N/A"}</>,
    },
  ];
  const change = (data) => {
    getTableData((data - 1) * 10);
  };

  const getSummaryData = async (skip) => {
    const url = `/partner/referral/${partnerContext.viewMode}/summary`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        // setPolicies(data.data);
        setSummaryData(data);
      })
      .catch((err) => {});
  };

  return (
    <div className="">
      {/* <div className="d-flex justify-content-center">
        {" "}
        <div
          className={`ph-summary h-[200px] p-4 shadow ${styles["partner-summary-card"]}`}
        >
          {" "}
          <div className="row">
            {" "}
            <div className="col">
              Total Policies: {amountFormat(summaryData?.totalPolicyCount)}
            </div>
            <div className="col">
              Total PH: {amountFormat(summaryData?.totalInvestor)}
            </div>
          </div>
          <div className="row mt-2">
            {" "}
            <div className="col">
              Gross IRR: {amountFormat(summaryData?.totalPolicyCount)}
            </div>
            <div className="col">
              Net Surrender Value:{" "}
              {amountFormat(summaryData?.totalCurrentSurrenderValue)}
            </div>
          </div>
          <div className="d-flex justify-content-center mt-2">
            Net Assignment Amount:{" "}
            {amountFormat(summaryData?.totalInvestmentAmount)}
          </div>
        </div>
      </div> */}
      <Table
        bordered={true}
        scroll={{ x: 400 }}
        loading={loading}
        className="table"
        dataSource={[...dataSource]}
        columns={columns}
        pagination={{
          pageSize: 10,
          total: paginationMetaData.count,
          onChange: change,
        }}
      />
    </div>
  );
}
